export const PENDING_TOOL_CALL_TOOL = {
  ADD_ADHOC_CONDITIONS: 'add_adhoc_conditions',
  ADD_CONDITIONS_FROM_LIBRARY: 'add_conditions_from_library',
  COMMIT_LOAN_CHANGES: 'commit_loan_changes',
};

// LEN-41: some [PendingChange] tools take NO arguments — they finalize state
// staged earlier in the run (e.g. commit_loan_changes drains the loan's staged
// draft buffer). Their confirmation payload is an empty object, so the raw-args
// path renders "{}" and the reviewer sees a confirmation with nothing to
// confirm. Give each a plain-language summary of what confirming does so the
// gate always states the action being approved.
export const NO_ARGUMENT_ACTION_SUMMARIES = {
  [PENDING_TOOL_CALL_TOOL.COMMIT_LOAN_CHANGES]:
    'Saves all changes staged earlier in this run to the live loan record. This cannot be undone.',
};

// LEN-41: tools whose real subject is the loan's STAGED changes (not their own
// empty args). For these the confirmation additionally fetches and lists the
// currently-staged changes so the reviewer sees exactly what will be committed —
// or an explicit "nothing is staged" state.
export const STAGED_CHANGES_REVIEW_TOOLS = new Set([PENDING_TOOL_CALL_TOOL.COMMIT_LOAN_CHANGES]);

export const CONDITION_TOOL_NAMES = new Set([
  PENDING_TOOL_CALL_TOOL.ADD_ADHOC_CONDITIONS,
  PENDING_TOOL_CALL_TOOL.ADD_CONDITIONS_FROM_LIBRARY,
]);

// The whole `edit_*` tool family (edit_loan_closing, edit_borrower, …) shares one
// patch shape, so the friendly field-change summary keys off this prefix rather
// than enumerating every tool.
export const EDIT_TOOL_PREFIX = 'edit_';

// Infrastructure / plumbing keys carried on the patch that mean nothing to a
// reviewer confirming a change — hidden from the friendly summary.
export const SKIPPED_ARG_KEYS = new Set(['requestMetadata', 'tabId']);

// Field keys whose auto-humanized label reads poorly. Auto-humanization already
// handles most keys (anticipatedClosingDate -> "Anticipated Closing Date"); only
// override the ones it gets wrong.
export const FIELD_LABEL_OVERRIDES = {
  closeAt: 'Closing Date',
};

// Numeric fields that read best as currency ("$540,000"). Everything else is
// shown as a thousands-grouped number so a bare ratio/count is never mislabeled
// as money.
export const MONEY_FIELD_KEYS = new Set([
  'appraisedValue',
  'purchasePrice',
  'salesPrice',
  'loanAmount',
  'downPayment',
  'estimatedValue',
]);

export const STEP_PENDING_TOOL_CALL_LABELS = {
  HEADLINE_PREFIX: 'Confirming will run:',
  CONDITIONS_HINT: ({ count }) =>
    count === 1
      ? 'This will add 1 condition to the loan:'
      : `This will add ${count} conditions to the loan:`,
  CHANGES_HINT: 'This will apply the following changes:',
  ARGUMENTS_LABEL: 'Arguments',
  NO_ARGUMENTS: 'No arguments provided.',
  UNKNOWN_TOOL: 'a tool',
  SELECTED_COUNT: ({ count }) => `${count} selected`,
};

export const StepPendingToolCallTestIds = {
  CONTAINER: 'AiActivity_StepPendingToolCall_Container',
  HEADLINE: 'AiActivity_StepPendingToolCall_Headline',
  CONDITIONS_HINT: 'AiActivity_StepPendingToolCall_ConditionsHint',
  CHANGES_HINT: 'AiActivity_StepPendingToolCall_ChangesHint',
  GENERIC_ARGUMENTS: 'AiActivity_StepPendingToolCall_GenericArguments',
  ACTION_SUMMARY: 'AiActivity_StepPendingToolCall_ActionSummary',
};

export const FieldChangeListTestIds = {
  CONTAINER: 'AiActivity_FieldChangeList_Container',
  ROW: 'AiActivity_FieldChangeList_Row',
  LABEL: 'AiActivity_FieldChangeList_Label',
  VALUE: 'AiActivity_FieldChangeList_Value',
};
